import React, { Component, Fragment } from 'react';
import { Layer } from 'react-konva';
import { connect } from 'react-redux';
import { ICardsRenderInfo, ILaid, RecordState } from '../../redux/types';
import HomeCard from '../HomeCard';
import { getPileX, getSlotY } from '../../utils';
import SlotBorder from '../SlotBorder';

const HOME_START_INDEX = 4;

type Props = {
  home: ILaid;
  cardParameters: ICardsRenderInfo;
  size: number;
};

class Home extends Component<Props> {
  render() {
    const { home, cardParameters, size } = this.props;
    const { width, height, corner } = cardParameters;
    const y = getSlotY(size);

    return (
      <Layer>
        {home.map((slot, index) => {
          const homeIndex = HOME_START_INDEX + index;
          const x = getPileX(homeIndex, size);
          return (
            <Fragment key={`Home-${index}`}>
              <SlotBorder corner={corner} x={x} y={y} width={width} height={height} />
              {slot.map((item, index) => {
                return <HomeCard index={index} cardParameters={cardParameters} card={item} x={x} y={y} />;
              })}
            </Fragment>
          );
        })}
      </Layer>
    );
  }
}

function mapStateToProps(state: RecordState) {
  return {
    home: state.getIn(['gameState', 'home']),
    cardParameters: state.getIn(['cardsRenderInfo']),
    size: state.get('size'),
  };
}

export default connect(mapStateToProps)(Home);
